import React from 'react';

const IconPlay = props => (
  <svg width="146px" height="146px" viewBox="0 0 146 146" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-836.000000, -8934.000000)">
        <g transform="translate(836.000000, 8934.000000)">
          <g>
            <mask fill="white">
              <circle cx="73" cy="73" r="73" />
            </mask>
            <circle fill="#27919C" fillRule="nonzero" cx="73" cy="73" r="73" />
          </g>

          <path
            d="M98.3490232,76.3498764 L59.9182672,98.5704846 C57.7194881,99.8002894 55,98.2465785 55,95.7211472 L55,51.2799307 C55,48.7544994 57.7169001,47.1981952 59.9182672,48.4305933 L98.3490232,70.6512015 C100.550326,71.946826 100.550326,75.0543166 98.3490232,76.3499411 L98.3490232,76.3498764 Z"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default IconPlay;
